import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import CmsContent from '../../CmsContent';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import useDevice from '../../../hooks/use-device';
import styles from './MultiColumn.less';

var MultiColumn = function MultiColumn(_ref) {
  var data = _ref.data;
  var device = useDevice();
  var isMobile = device.isMobile();

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var _ref2$component$conte2 = _ref2$component$conte.column,
      column = _ref2$component$conte2 === void 0 ? [] : _ref2$component$conte2;
  return column && Array.isArray(column) && column.length ? /*#__PURE__*/React.createElement(Block, {
    className: getClasses({
      styles: styles,
      classes: ['cms-multicolumn'],
      device: device
    }),
    layout: true,
    vertical: isMobile,
    "data-en": 'cms-multicolumn'
  }, column.map(function (content, index) {
    return /*#__PURE__*/React.createElement(Block, {
      m: "s",
      style: isMobile ? {} : {
        width: "".concat(100 / column.length, "%")
      },
      key: index,
      layout: true,
      vertical: true,
      center: isMobile
    }, /*#__PURE__*/React.createElement(CmsContent, {
      content: content
    }));
  })) : null;
};

MultiColumn.propTypes = {
  data: PropTypes.object.isRequired
};
export default MultiColumn;